export default function LoadingScreen({ error }) {
    return (
        <div
            className="min-h-screen bg-[#0B0B0C] flex items-center justify-center"
            data-testid="private-detail-loading"
        >
            <div className="w-32 h-px bg-[rgba(201,168,106,0.3)] relative overflow-hidden">
                <span className="absolute inset-y-0 left-0 w-1/3 bg-[#C9A86A] animate-[slide_1.2s_ease-in-out_infinite]" />
            </div>
            <style>{`@keyframes slide {0%{transform:translateX(-100%)}100%{transform:translateX(400%)}}`}</style>
            {error && (
                <div className="absolute bottom-10 text-[#C97A6A] text-sm">
                    {error}
                </div>
            )}
        </div>
    );
}
